(function () {
    'use strict';

    angular.module("imApp").factory("persFactsEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getPersFactsEdit: function (parms) {
                return $ihttp.post({
                    method: 2925,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2926,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2927,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
